<template>
  <modal v-bind="modalParams" @modalClick="cancel">
    <transition name="popup">
      <div v-show="isShow" class="action-picker">
        <div class="action-picker-header">
          <p class="cancel" @click="cancel">
            {{ cancelText }}
          </p>
          <p class="title">
            {{ titleText }}
          </p>
          <p class="completed" @click="completed">
            {{ confirmText }}
          </p>
        </div>
        <div class="action-picker-content">
          <Picker class="action-picker-item" v-bind="lists" @onChange="onChange" />
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '../Modal'
import Picker from '../Picker'
export default {
  components: {
    Modal,
    Picker
  },
  props: {
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    titleText: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    forceUpdate: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      value: false,
      isShow: false,
      callback: null,
      selectData: {},
      lists: {
        data: [],
        selectedIndex: 0
      },
      modalParams: {
        showModal: false,
        lockScroll: true
      }
    }
  },
  watch: {
    value (newVal) {
      this.modalParams.showModal = newVal
      this.isShow = newVal
      this.setLists()
      this.setSelectData()
    }
  },
  methods: {
    handleAction (action) {
      this.isShow = false
      setTimeout(() => {
        this.modalParams.showModal = false
        this.value = false
        this.callback(action)
      }, 300)
    },
    setSelectData () {
      const data = this.forceUpdate
        ? this.actions[this.currentIndex] : this.actions[this.selectedIndex]
      this.selectData = {
        index: this.selectedIndex,
        ...data
      }
    },
    setLists () {
      this.lists.data = this.actions
      this.lists.data.forEach(item => {
        item.text = item.name
      })
      this.lists.selectedIndex = this.forceUpdate ? this.currentIndex : this.selectedIndex
    },
    onChange (data) {
      this.currentIndex = data.index
      this.selectData = data
      this.selectData.name = data.text
    },
    cancel () {
      this.handleAction({
        ...this.selectData,
        action: 'cancel'
      })
    },
    completed () {
      this.handleAction({
        ...this.selectData,
        action: 'success'
      })
    },
    closeMask () {
      this.isShow = false
      this.modalParams.showModal = false
      this.value = false
    }
  }
}
</script>
<style lang="scss" scoped>
.action-picker {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: $color-bg-white;
  .action-picker-header {
    @include border-bottom;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 15px 20px;
    p {
      color: $color-text;
      font-size: $span-font-size;
      line-height: 14px;
      text-align: center;
    }
    p.cancel {
      flex: 1;
      font-size: $base-font-size;
      line-height: 16px;
      text-align: left;
    }
    p.completed {
      flex: 1;
      color: $color-primary;
      font-size: $base-font-size;
      line-height: 16px;
      text-align: right;
    }
  }
  .action-picker-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 206px;
    .action-picker-item {
      flex: 1;
    }
  }
}
.popup-enter-active {
  animation: slide-in 0.3s ease;
}
.popup-leave-active {
  animation: slide-out 0.3s ease;
}
@keyframes slide-in {
  0% {
    margin-bottom: -100%;
  }
  100% {
    margin-bottom: 0;
  }
}
@keyframes slide-out {
  0% {
    margin-bottom: 0;
  }
  100% {
    margin-bottom: -100%;
  }
}
</style>
